import { useState } from 'react';

import {
  AlertMessage,
  AlertMessageType,
} from '@gasbi/shared/common/components/AlertMessage';

import { FormFieldPreview } from '@/components/FormikField';
import { getHistoryButtonStyle } from '@/components/ui/HistoryButton';
import { InfoBox } from '@/components/ui/InfoBox';
import { TechnologicalLossHistoryModel } from '@/features/balanceActs/types';

import { useTheme } from '@mui/joy';
import Button from '@mui/joy/Button';
import Stack from '@mui/joy/Stack';

import { InformationSkeleton } from '@components/ui/skeletons';

import HistoryIcon from '@assets/history.svg?react';

import LossHistoryModal from '../LossHistoryModal';

interface GeneralInformationProps {
  maxGasConsumption: number;
  isLoading: boolean;
  lossHistory?: TechnologicalLossHistoryModel[];
  technologicalLossErrorMessage?: string | null;
}

export const GeneralInformation = ({
  maxGasConsumption,
  isLoading,
  technologicalLossErrorMessage,
  lossHistory = [],
}: GeneralInformationProps) => {
  const theme = useTheme();
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const formattedValue = new Intl.NumberFormat('uk-UA').format(
    maxGasConsumption,
  );

  return (
    <>
      <InformationSkeleton loading={isLoading}>
        <InfoBox label='Загальна інформація'>
          <Stack
            direction='row'
            justifyContent='space-between'
            alignItems='center'
          >
            <FormFieldPreview label='Максимальне ВТВ по Акту (м³/доба)'>
              {technologicalLossErrorMessage ? (
                <AlertMessage type={AlertMessageType.Error}>
                  {technologicalLossErrorMessage}
                </AlertMessage>
              ) : (
                formattedValue
              )}
            </FormFieldPreview>
            {lossHistory.length > 0 && (
              <Button
                variant='solid'
                startDecorator={<HistoryIcon />}
                onClick={() => setIsHistoryOpen(true)}
                sx={{
                  ...getHistoryButtonStyle(theme),
                  fontSize: theme => theme.fontSize.md,
                }}
              >
                Історія розрахунків
              </Button>
            )}
          </Stack>
        </InfoBox>
      </InformationSkeleton>

      <LossHistoryModal
        open={isHistoryOpen}
        onClose={() => setIsHistoryOpen(false)}
        data={lossHistory}
      />
    </>
  );
};
